<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_block"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<span>加入库尔</span>&ensp;&ensp;一起改变全球诊断！！
			</div>
			<!--banner-->
			<!--块1-->
			<div v-if="infoData" class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit_box">
					<div class="tit">
						<div class="tit">{{ infoData.title }}</div>
						<div class="btn">
							<a style="color: #ffffff;" href="mailto:makuluno1@163.com" target="">申请职位</a>
						</div>
					</div>
					<div class="txt1">
						<span><van-icon name="todo-list-o" size="18px" color="#999999" style="top: 3px;" /> {{ infoData.post_name }}</span>&ensp;&ensp;
						<span><van-icon name="location-o" size="18px" color="#999999" style="top: 3px;" /> {{ infoData.address_name }}</span>
					</div>
					<div class="txt2">
						<van-icon name="clock-o" size="18px" color="#999999" style="top: 3px;" /> 发布时间：<span>{{ infoData.fabu_time }}</span>
					</div>
					<div class="tips_box">
						<div>{{ infoData.jingyan }}</div>
						<div>{{ infoData.xueli }}</div>
						<div>招聘人数：{{ infoData.reason_num }}人</div>
					</div>
				</div>
				<div class="content_box">
					<div class="zz_box">
						<div class="tit">岗位职责</div>
						<div class="txt" v-html="parsedText(infoData.zhize)"></div>
					</div>
					<div class="yq_box">
						<div class="tit">任职要求</div>
						<div class="txt" v-html="parsedText(infoData.yaoqiu)"></div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="3000" show-indicators :stop-propagation="false" indicator-color="#A50073">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @click="goCulture(index)" />
						</div>
					</van-swipe-item>
				</van-swipe>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/h5/nav.vue'  //导航组件
import footerBox from '@/component/h5/footer.vue'  //版权组件
import { jobList, jobInfo } from '@/api/public';  //筛选列表
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [
				{ imgUrl: require('@/assets/img_public/job/block01_h5.webp') },
				{ imgUrl: require('@/assets/img_public/job/block02_h5.webp') }
			],
			infoData: null,
			type: null,
			infoId: null,
		}
	},
	created(){
		let that = this;
		if(that.$route.params.type && that.$route.params.jobInfoId) {
			that.type = that.$route.params.type;
			that.infoId = that.$route.params.jobInfoId.split('.')[0];
			//请求详情
			that.getInfo(that.infoId);
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//跳转企业文化
		goCulture(index) {
			if(index == 1) {
				this.$router.push({ path: '/about/culture.html' });
			}
		},
		//处理数据格式
		parsedText(value) {
			return value.replace(/\n/g, "<br>");
		},
		//切换项目
		checkInfo(value) {
			let that = this;
			that.getInfo(value.id);
		},
		//请求详情
		getInfo(value) {
			let that = this;
			that.$toast.loading({ message: '', forbidClick: true, duration: 0 });
			jobInfo({ id: value }).then(res => {
				that.infoData = res.data;
				that.$toast.clear();
			});
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块2
	.block_2{
		padding: 40px 20px;
		background-color: #F7F6F9;
		.swipe_box{
			.swiper_el{
				img.bg{
					width: 100%;
				}
			}
		}
	}
	//块1
	.block_1{
		padding: 40px 20px;
		.content_box{
			padding: 30px 0 10px 0;
			word-break: break-all;
			.zz_box, .yq_box{
				padding-bottom: 50px;
				.tit{
					padding: 10px 0;
					font-size: 18px;
					font-weight: bold;
				}
			}
		}
		.tit_box{
			padding-bottom: 18px;
			border-bottom: 1px solid rgba(0, 0, 0, 0.1);
			.tips_box{
				padding-top: 20px;
				div{
					display: inline-block;
					margin: 0 12px 12px 0;
					padding: 4px 8px;
					border-radius: 6px;
					background-color: #F7F6F9;
					color: #A50073;
				}
			}
			.txt2{
				span{
					font-size: 15px;
				}
			}
			.txt1{
				padding: 12px 0 6px 0;
			}
			.tit{
				display: flex;
				align-items: center;
				.tit{
					flex: 1;
					font-size: 22px;
					font-weight: bold;
				}
				.btn{
					width: 100px;
					height: 40px;
					line-height: 40px;
					background: linear-gradient( 90deg, #CF0272 0%, #A20073 100%);
					border-radius: 8px;
					font-size: 16px;
					color: #ffffff;
					text-align: center;
					cursor: pointer;
				}
			}
		}
	}
	.banner_block{
		width: 100%;
		height: 60px;
		line-height: 60px;
		background: linear-gradient( 90deg, #A50073 0%, #C7007E 49%, #A50073 100%);
		text-align: center;
		color: #ffffff;
		font-size: 16px;
		span{
			font-size: 16px;
			font-weight: bold;
		}
	}
}
</style>